<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <base-text-field
      v-model="name"
      label="Nombre"
    />

    <base-text-field
      v-model="email"
      label="Email"
    />

    <base-text-field
      v-model="subject"
      label="Asunto"
    />

    <base-textarea
      v-model="body"
      class="mb-6"
      label="Escriba aquí"
    />

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      :href="dataMail"
      outlined
      target="_blank"
    >
      Enviar mensaje
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'ENVÍENOS UN MENSAJE',
      },
    },

    data: () => ({
      email: '',
      name: '',
      subject: '',
      body: '',
    }),

    computed: {
      dataMail () {
        return `mailto:info@paintcleanbox.com?subject=${this.subject}&from=${this.name} <${this.email}>&body=${this.body}`
      },
    },
  }
</script>
